module.exports = function() {
  return new Worker(__webpack_public_path__ + "5671494c4b7d96911829.worker.js");
};